// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"74":"About","88":"potba-configurations","581":"potba-home","764":"potba-parent","784":"Logins"}[chunkId] || chunkId) + "." + {"74":"8dafe141","88":"2df71b03","107":"f1da04b6","581":"e6cce7f2","764":"270036e9","784":"140294d9"}[chunkId] + ".js";
};